import { useEffect, useRef, useState } from "react";
import styles from "./DrawerIframe.module.scss";
import classNames from "classnames";
import { TTP_OFFFCOURSE_URL } from "../../../config";
import { encryptAES } from ".";
import { useSelector } from "react-redux";

const prepareWatchParams = (user, token, lng) => {
  const params = {};
  if (user && token) {
    params["auth"] = {
      id: user.id,
      token,
    };
  }
  if (lng) {
    params["preferences"] = { language: lng };
  }
  params["app"] = "WATCH";

  return encryptAES(JSON.stringify(params));
};

const prepareWebinarParams = (user, token) => {
  const param = ["token=" + token];
  if (user) {
    param.push("userId=" + user.id);
  }
  return encryptAES(param.join());
};

export default function WatchIframe({ lng }) {
  const [iframeSrc, setIframeSrc] = useState("");
  const [modalOpened, setModalOpened] = useState(false);

  const { token, user } = useSelector((state) => state.auth);

  const authRef = useRef({ token, user, lng });
  useEffect(() => {
    authRef.current = { token, user, lng };
  }, [token, user, lng]);

  const offfcoursePathRef = useRef("");

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.event === "OPEN_MODAL") {
        setModalOpened(true);
      }
      if (event.data?.event === "CLOSE_MODAL") {
        setModalOpened(false);
      }
      if (event.data?.event === "WATCH_PATH_CHANGE" && event.data.path) {
        offfcoursePathRef.current = event.data.path;
      }
      if (event.data?.event === "OPEN_WEBINAR") {
        const webinarUrl = event.data.message;
        const { token: t, user: u } = authRef.current;
        const encryptedParams = prepareWebinarParams(u, t);
        const separator = webinarUrl.includes("?") ? "&" : "?";
        setIframeSrc(
          webinarUrl +
            separator +
            "params=" +
            encodeURIComponent(encryptedParams)
        );
      }
      if (event.data?.event === "OPEN_OFFFCOURSE") {
        const { token: t, user: u, lng: l } = authRef.current;
        const encryptedParams = prepareWatchParams(u, t, l);
        const path = offfcoursePathRef.current || `/${l}`;
        const base = `${TTP_OFFFCOURSE_URL}${
          path.startsWith("/") ? path : `/${path}`
        }`;
        const separator = base.includes("?") ? "&" : "?";
        setIframeSrc(
          base + separator + "params=" + encodeURIComponent(encryptedParams)
        );
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    if (!token) {
      return;
    }

    const encryptedParams = prepareWatchParams(user, token, lng);
    const src =
      `${TTP_OFFFCOURSE_URL}/${lng}` +
      "?params=" +
      encodeURIComponent(encryptedParams);

    setIframeSrc(src);
  }, [lng, token]);

  return (
    <div
      className={classNames(styles.wrapper, modalOpened && styles.modalOpen)}
    >
      <iframe
        id="watch-iframe"
        src={iframeSrc}
        className={styles.iframe}
        allow="camera;microphone;autoplay;fullscreen"
      />
    </div>
  );
}
